import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config"; // Adjust to correct config path
const userInfo = localStorage.getItem("userInfo");

export const initialState = {
  formData: {
    FirstName: "", // Required
    LastName: "", // Required
    SurName: "", // Required
    Gender: "Male", // Required
    DOB: "", // Required
    Nationality: "", // Required
    PreviousSchool: "", // Required
    SpecialNeeds: "", // Required
    PhoneNumber: "", // Required
    IncomeType: "", // Required
    IncomeLevel: "", // Required
    RequestedSchool: "", // Required
    BatchYear: "", // Required
    CurriculumType: 0, // Required, default to 0
    ContactEmail: userInfo?.userName || "", // Required
    BatchName: "", // Additional field
    SchoolName: "", // Additional field
    Curriculum: "", // Additional field
    YellowCardPhoto: "",
    PreviousSchoolReportCard: "",
  },
  status: "idle",
  error: null,
  success: false,
  schools: [],
  batches: [],
};
export const createEnquiry = createAsyncThunk(
  "enquiry/createEnquiry",
  async ({ formData, base64Strings }, { rejectWithValue, getState }) => {
    const state = getState();
    
    const isAuthenticated = state.auth.isAuthenticated;
    // Get the auth state from the state
    console.log("formData @ createEnquiry", formData);

    // Prepare processedFormData by excluding unnecessary keys
    const processedFormData = {
      admissionWindowID: formData.selectedAdmissionWindowId,
      firstName: formData.FirstName,
      lastName: formData.LastName,
      surName: formData.SurName,
      gender: parseInt(formData.Gender),
      dob: formData.DOB,
      nationality: formData.Nationality,
      previousSchool: formData.PreviousSchool || "Not Applicable",
      specialNeeds: formData.SpecialNeeds,
      phoneNumber: formData.PhoneNumber,
      incomeType: parseInt(formData.IncomeType),
      incomeLevel: parseInt(formData.IncomeLevel),
      requestedSchool: formData.SchoolName,
      batchYear: formData.BatchYear,
      curriculumType: formData.CurriculumType || 0,
      yellowCardPhoto: base64Strings?.YellowCardPhoto || "",
      previousSchoolReportCard:
        base64Strings?.PreviousSchoolReportCard || "",
      prevousSchoolReportCard:
        base64Strings?.PreviousSchoolReportCard || "",

      ...(!isAuthenticated && {
        contactEmail: formData.ContactEmail,
      }),
    };
    console.log("processedFormData", processedFormData);
    const endpoint = isAuthenticated
      ? `${API_BASE_URL}/api/ApplicantStudent/Authenticated`
      : `${API_BASE_URL}/api/ApplicantStudent/Unauthenticated`;

    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    if (isAuthenticated) {
      const token = localStorage.getItem("token");
      headers.Authorization = `Bearer ${token}`;
    }
    console.log("headers", headers);

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(processedFormData),
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Form submission error:", {
          status: response.status,
          errorText: errorText,
        });

        return rejectWithValue(errorText || "Form submission failed");
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error("Comprehensive error in form submission:", error);
      return rejectWithValue(
        error.message || "Unexpected error during form submission"
      );
    }
  }
);

const applicationEnquirySlice = createSlice({
  name: "applicationEnquiry",
  initialState,
  reducers: {
    // Other reducers if necessary
    updateFormField(state, action) {
      const { name, value } = action.payload;
      console.log("Updating form fields", name, value);
      state.formData[name] = value;
    },
    resetForm(state) {
      state.formData = initialState.formData;
      state.status = "idle";
      state.error = null;
      state.success = false;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
    clearSuccess(state) {
      state.success = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(createEnquiry.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createEnquiry.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.success = true;
        state.error = null;
      })
      .addCase(createEnquiry.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.success = false;
      });
  },
});
export const {
  updateFormField,
  resetForm,
  setError,
  clearError,
  clearSuccess,
} = applicationEnquirySlice.actions;
export default applicationEnquirySlice.reducer;
